// Maps the server-side `stage` enum (closed set: preprocess|researching|
// postprocess) to user-facing copy. Unknown stages render the generic
// "Working" fallback so the client stays forward-compatible with new
// stages the server might add without a coordinated client deploy.
//
// Only `researching` carries a percentage suffix — the other stages are
// short and atomic. Progress 0 or null suppresses the suffix too. The
// forecaster's inner agent loop emits a progress percentage on every
// agent turn (mapped from turn/max_turns), so the % climbs smoothly
// instead of jumping from 0 to 95.

// Progress arrives from the SSE stream as either a 0–1 fraction or an already
// 0–100 percent; the server applies this same mapping before persisting
// last_progress, so mirror it for consistent in-session / persisted / hydrated
// values. Returns null for a non-number so callers can show "unknown" (not 0%).
export function normalizePct(p) {
  if (!Number.isFinite(p)) return null; // rejects non-number, NaN, ±Infinity
  const raw = p > 0 && p < 1 ? p * 100 : p;
  return Math.max(0, Math.min(100, Math.round(raw))); // round THEN clamp — mirrors the server tap
}

// No trailing ellipsis — the running chat line appends its own animated "…", so a
// baked-in one would double up ("Writing the forecast……").
const _LABELS = {
  preprocess: "Checking your question",
  researching: "Researching sources",
  postprocess: "Writing the forecast",
};

// Used by the run-store progress dispatch (App.jsx onProgress / onProgressForRoot):
// the formatted label becomes runProgress(...).message, which selectChatProjection
// renders on the running event line. The former applyStageLabel placeholder-rewriter
// was retired in Ring 3 once the chat line went fully run-projected.
export function formatStageLabel(stage, progress) {
  const base = _LABELS[stage] || "Working";
  if (stage === "researching" && typeof progress === "number" && progress > 0) {
    return `Researching sources, ${progress}% done`;
  }
  return base;
}
